export default __webpack_public_path__ + "static/media/xusd-logo-ellipse-transparent-260x260.b939e66b.svg";